query Countries {
  countries(orderBy: COUNTRY_ASC) {
    nodes {
      id
      country
    }
  }
}
